module.exports = __webpack_public_path__ + "img/the-graph-logo.bf7a1739.svg";